import React from "react";
import { CenterContainer, Label, Card, Container, Title, SectionDivider } from './ContactStyles';
import { useState, useRef } from 'react';
import emailjs from'@emailjs/browser'
import { color } from "framer-motion";


//service_9p5396c
//template_yqrra0f
//qXJrd_j3e3bFEcz7_

const Contact = () => {
    const formRef = useRef();
    const [form, setForm] = useState({
        name: '',
        email: '',
        message: '',
    })

    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm({ ...form, [name]: value})
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        emailjs.send(
            'service_9p5396c',
            'template_yqrra0f',
            {
                from_name: form.name,
                to_name: 'Kanav',
                from_email: form.email,
                to_email: 'jainkanav25@yahoo.com',
                message: form.message,
            },
            'qXJrd_j3e3bFEcz7_'
        )
        .then(() => {
            setLoading(false);
            alert('Thank you! I will get back to you at the earliest.');
            setForm({
                name: '',
                email: '',
                message: '',
            })
        }, (error) => {
            setLoading(false)
            console.log(error);
            alert('Something went wrong.')
        })
    }

    return(
        <div id="contact" >
        <SectionDivider />
        <Container>
            <Title>Contact Me</Title>
            <Card>
                <CenterContainer>
                <form
                    ref={formRef}
                    onSubmit={handleSubmit}
                    style={{textAlign: 'Left'}}
                    className="mt-12 flex flex-col gap-8"
                >
                    <label style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
                        <Label>Your Name</Label>
                        <input 
                            type="text"
                            name="name"
                            value={form.name}
                            onChange={handleChange}
                            placeholder="What's your name?"
                            style={{
                                backgroundColor: 'rgb(27, 46, 82)',
                                borderRadius: '10px',
                                textAlign: 'left',
                                padding: '10px',
                                width: '90%',
                                border: 'none',
                                color: 'white'
                            }}
                        />
                    </label><br />

                    <label style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
                        <Label>Your Email ID</Label>
                        <input 
                            type="email"
                            name="email"
                            value={form.email}
                            onChange={handleChange}
                            placeholder="What's your web address?"
                            style={{
                                backgroundColor: 'rgb(27, 46, 82)',
                                borderRadius: '10px',
                                textAlign: 'left',
                                padding: '10px',
                                width: '90%',
                                border: 'none',
                                color: 'white'
                            }}
                        />
                    </label><br />

                    <label style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
                        <Label>Your Message</Label>
                        <textarea
                            rows="7" 
                            name="message"
                            value={form.message}
                            onChange={handleChange}
                            placeholder="Type your message here."
                            style={{
                                backgroundColor: 'rgb(27, 46, 82)',
                                borderRadius: '10px',
                                textAlign: 'left',
                                padding: '10px',
                                width: '90%',
                                border: 'none',
                                color: 'white'
                            }}
                        />
                    </label><br /><br />

                    <button
                        type="submit"
                        style={{
                            backgroundColor: 'rgb(27, 46, 82)',
                            border: 'none',
                            borderRadius: '10px',
                            color: 'white',
                            padding: '10px',
                            alignSelf: 'flex-start'
                        }} 
                    >
                        {loading ? 'Sending...' : 'Send'}
                    </button><br /><br />

                </form>
                </CenterContainer>
            </Card>
        </Container>
    </div>
    )
};

export default Contact;